import React, { Component } from 'react';
import { Link,Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class Part5 extends Component {

    render() {

        var userToken = localStorage.getItem('token');
        if (!userToken) {
            return <Navigate to='/login' replace="true" />
        }

        return (
            <div className="docs-content">
                <div className="container">

                    {/* ========================= */}
                    {/* 1. IDEMPOTENCY */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            9. Idempotency
                        </h1>

                        <div className="alert alert-info">
                            Guarantees that repeating the same request does not cause duplicate execution.
                        </div>

                        <h5 className="mt-4">Canonical Rule</h5>

                        <div className="alert alert-warning mt-3">
                            Idempotency is enforced by the platform, not trusted to PSPs.
                        </div>

                        <h5 className="mt-4">Required Fields</h5>

                        <div className="card p-3 mt-3">
                            <ul className="mb-0 doc-page">
                                <li><strong>canonical_idempotency_key</strong></li>
                                <li><strong>provider_reference</strong></li>
                                <li><strong>request_hash</strong></li>
                            </ul>
                        </div>

                    </article>


                    {/* ========================= */}
                    {/* 2. ASYNC MODEL TYPES */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            10. Async Model Types
                        </h1>

                        <div className="card p-3 mt-3">
                            <ul className="mb-0 doc-page">

                                <li>
                                    <strong>Synchronous</strong><br />
                                    Immediate final result.
                                </li>

                                <li className="mt-3">
                                    <strong>Polling</strong><br />
                                    The client must query the status.
                                </li>

                                <li className="mt-3">
                                    <strong>Webhook</strong><br />
                                    PSP pushes updates.
                                </li>

                                <li className="mt-3">
                                    <strong>Hybrid</strong><br />
                                    A combination of the above.
                                </li>

                            </ul>
                        </div>

                        <div className="alert alert-dark mt-4">
                            Webhook events must be:
                            <ul className="mb-0 mt-2">
                                <li><strong>Signed</strong></li>
                                <li><strong>Deduplicated</strong></li>
                                <li><strong>Mapped to canonical states</strong></li>
                            </ul>
                        </div>

                    </article>


                    {/* ========================= */}
                    {/* 3. FAILURE MODES */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            11. Failure Modes
                        </h1>

                        <div className="card p-3 mt-3">
                            <ul className="mb-0 doc-page">

                                <li>
                                    <strong>Rejected</strong><br />
                                    Input or compliance issue.
                                </li>

                                <li className="mt-3">
                                    <strong>Failed</strong><br />
                                    PSP/system error.
                                </li>

                                <li className="mt-3">
                                    <strong>Expired</strong><br />
                                    Quote or transaction timeout.
                                </li>

                                <li className="mt-3">
                                    <strong>Reversed / Refunded</strong><br />
                                    Post-completion correction.
                                </li>

                            </ul>
                        </div>

                        <div className="alert alert-warning mt-4">
                            Failures are data, not exceptions. They must be classified and stored.
                        </div>

                    </article>

                    <article class="docs-article" id="section-3">
                        <section class="docs-section row" id="item-3-1">
                            <div class="col-12">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-four-doc" tabIndex="-1"
                                                aria-disabled="true"><i class="bi bi-arrow-left"></i> &nbsp;
                                                Part IV
                                            </Link>
                                        </li>
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-six-doc">
                                                Part VI &nbsp; <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </section>
                    </article>

                </div>

                <ToastContainer closeOnClick autoClose={2000} />
            </div>
        )
    }
}